import { createSelector } from 'reselect';
import { FLAG_POPOUT_PRESENTATIONS } from 'constants/FeatureFlags';
import {
  callSelectors,
  conferenceParticipantsSelectors,
  currentUserSelectors,
  featureSelectors,
  mediaSelectors
} from '@lifesize/nucleus';
import { get, partition } from 'lodash';

const activeCallSelector = state => callSelectors.activeCallSelector(state);
const popoutPresentationFeatureFlag = state =>
  featureSelectors.getFeatureFlag(state)(FLAG_POPOUT_PRESENTATIONS);
const hasPresentationSelector = state => get(state, 'app.inCallVideo.shouldDisplaySecondaryVideo');
const popoutPresentationPoppedSelector = state => get(state, 'app.inCallVideo.videoLayout.popoutPresentation');
const remotePresentationStreamSelector = state => mediaSelectors.selectMedia(state).remotePresentationStream;

export const popoutPresentationFeatureSelector = createSelector(
  popoutPresentationFeatureFlag,
  (popoutPresentationFeature, pluginSupported) => (
    popoutPresentationFeature && !pluginSupported
  )
);

export const popoutPresentationSelector = createSelector(
  popoutPresentationFeatureSelector,
  popoutPresentationPoppedSelector,
  remotePresentationStreamSelector,
  (popoutPresentationFeature, presentationIsPopped, remotePresentationStream) => (
    popoutPresentationFeature && presentationIsPopped && !!remotePresentationStream
  )
);

export const inlinePresentationSelector = createSelector(
  activeCallSelector,
  popoutPresentationSelector,
  hasPresentationSelector,
  (activeCall, popoutPresentation, hasPresentation) => {
    const showPresentation = hasPresentation && activeCall.hasIncomingPresentation;
    return (showPresentation && !popoutPresentation);
  }
);

export const sortedParticipantListSelector = createSelector(
  conferenceParticipantsSelectors.selectParticipantListSorted,
  currentUserSelectors.getUserUUID,
  (participants, userUuid) => {
    // CA-1381: Show current user as first in sorted participants list
    const [self, others] = partition(participants, p => get(p, 'uuid') === userUuid);
    const sorted = others.sort((a, b) => (a.name > b.name ? 1 : -1));
    return [...self, ...sorted];
  }
);
